var map = {
	"./facebook.png": 52510,
	"./instagram.png": 28673,
	"./line.png": 96364,
	"./linkedin.png": 37410,
	"./pinterest.png": 30274,
	"./skype.png": 89890,
	"./telegram.png": 77433,
	"./twitter.png": 27248,
	"./wechat.png": 95356,
	"./whatsapp.png": 35139
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20705;